/* 
    This component is shown every time an internal route is not found
*/

export default function NotFound() {
    return ( 
    <main style={{ padding: "1rem" }}>
        <h1>Error: Resource not found</h1>
    </main>);
}

